export const WebUiCalcFormEnI18n = {
    fields: {
        amount: {
            label: 'Select Investment Amount',
        },
        numberOfShares: {
            label: 'Or enter number of shares',
        },
        frequency: {
            label: 'Select Investment Frequency',
            options: {
                weekly: {
                    title: 'Weekly',
                    description: 'Provides faster growth',
                },
                monthly: {
                    title: 'Monthly',
                    description: 'Slower growth',
                },
            },
        },
        return: {
            label: 'Investment Return',
            error: 'Investment Return is required',
        },
        horizon: {
            label: 'Investment Horizon (years)',
        },
    },
    calc: {
        title: 'Calculator',
        chart: {
            title: 'Projected Performance',
            description: 'If you invest ${{ amount }} {{ frequency }} for {{ horizon }} years at an {{ return }}% annual return:',
        },
        table: {
            contribution: 'Weekly contribution:',
            total: 'Your total {{ horizon }}y contributions: ',
            portfolio: 'Final portfolio value:',
            growth: 'Total growth from the market:',
            share: 'Share of your wealth created by compounding:',
        },
        note: 'The projected figures are based on the assumption that all dividends will be reinvested and do not account for variations in market conditions or future dividend policies.',
    },
};
